// react
import * as React from "react";
import copy from "copy-to-clipboard";
// Mui
import Snackbar from "@mui/material/Snackbar";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { Icon } from "@iconify/react";
import Fade from "@mui/material/Fade";
import { Tooltip } from "@mui/material";
// styles
import styles from "src/components/UI/Picker/assets/scss/Picker.module.scss";
// Data
import Store from "src/data/store";

const store = Store.getInstance();

interface PickerMessageProps {
  open: boolean;
  onClose: () => void;
  pickedCoordinates: { longitude: number; latitude: number };
}
const PickerMessage = ({
  open,
  onClose,
  pickedCoordinates,
}: PickerMessageProps) => {
  const [msgText, setMsgText] = React.useState("");
  const [copiedMessageVisible, setCopiedMessageVisible] = React.useState(false);

  const handleClose = (
    event: React.SyntheticEvent | Event,
    reason?: string
  ) => {
    if (reason === "clickaway") {
      return;
    }
    onClose();
  };
  const handleCloseCopiedMsg = () => {
    setCopiedMessageVisible(false);
  };
  React.useEffect(() => {
    const latitude = pickedCoordinates.latitude.toFixed(8);
    const longitude = pickedCoordinates.longitude.toFixed(8);
    setMsgText(`Lat: ${latitude}, Long: ${longitude}`);
  }, [pickedCoordinates]);
  const handleCopy = () => {
    copy(`${pickedCoordinates.latitude},${pickedCoordinates.longitude}`);
    setCopiedMessageVisible(true);
    setTimeout(() => {
      setCopiedMessageVisible(false);
    }, 3500);
  };

  const action = (
    <React.Fragment>
      <Tooltip
        title="Copy-to-clipboard"
        placement="top"
        TransitionComponent={Fade}
        TransitionProps={{ timeout: 400 }}
      >
        <IconButton
          size="small"
          aria-label="Copy-to-clipboard"
          color="inherit"
          onClick={handleCopy}
        >
          {/* <Icon icon="radix-icons:copy" color="#c4e9ff" /> */}
          <ContentCopyIcon
            sx={{ color: "#c4e9ff", fill: "#c4e9ff", fontSize: "1.225rem" }}
          />
        </IconButton>
      </Tooltip>
      <IconButton
        size="small"
        aria-label="close"
        color="inherit"
        onClick={handleClose}
      >
        <CloseIcon fontSize="small" />
      </IconButton>
    </React.Fragment>
  );
  return (
    <>
      <Snackbar
        open={open}
        onClose={handleClose}
        message={msgText}
        action={action}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        className={`${styles.snackbar} ${styles.rightArrowSnackbar}`}
      />
      {copiedMessageVisible && (
        <Snackbar
          open={copiedMessageVisible}
          onClose={handleCloseCopiedMsg}
          anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
          message={
            <span>
              <Icon icon="mdi:success" color="white" fontSize="1rem" />
              <span style={{ top: "-0.2rem", position: "relative" }}>
                {" "}
                Copied to clipboard.
              </span>
            </span>
          }
          autoHideDuration={2000}
          className={styles.copiedMessage}
        />
      )}
    </>
  );
};
export default PickerMessage;
